module.exports = __webpack_public_path__ + "GSNgames-d9a1517e.webp";